import * as React from 'react';

import { ITeamBulkUploadDiff } from '@Shared/team_bulk_upload';

import * as style from './TeamBulkUploadSingleDiff.styl';

interface ITeamBulkUploadSingleDiffProps {
  diff: ITeamBulkUploadDiff;
}

function constructField(key: string, value: string | number | boolean, header: string, errorMap: Record<string, string>) {
  return (
    <div className="field">
      {header}: {value || <em>None</em>}
      {errorMap[key] ? <span className="error">{errorMap[key]}</span> : null}
    </div>
  );
}

export class TeamBulkUploadSingleDiff extends React.Component<ITeamBulkUploadSingleDiffProps> {
  constructor(props: ITeamBulkUploadSingleDiffProps) {
    super(props);
  }

  render() {
    const { diff } = this.props;

    const teamFields = diff.teamFields.map((field, j) => (
      <div key={j}>{constructField(field.bucket.toLowerCase(), field.value, field.bucket, diff.fieldErrorMap)}</div>
    ));

    const displayCardIssuingDiff = window.ORG.is_manager_card_issuing_enabled && diff.cardIssuingRules;

    return (
      <div className={style.global}>
        <em className="identifier">{diff.email}</em>
        <div className="fields">
          {diff.role && constructField('role', diff.role, 'Role', diff.fieldErrorMap)}
          {diff.managerEmail !== undefined && constructField('managerEmail', diff.managerEmail, 'Manager', diff.fieldErrorMap)}
          {diff.employeeId !== undefined && constructField('employeeId', diff.employeeId, 'Employee ID', diff.fieldErrorMap)}
          {diff.travelEnabled !== undefined && constructField('travelEnabled', diff.travelEnabled, 'Travel Enabled', diff.fieldErrorMap)}
          {displayCardIssuingDiff &&
            diff.cardIssuingRules.managerCardIssuingLimit !== undefined &&
            constructField(
              'managerCardIssuingLimit',
              diff.cardIssuingRules.managerCardIssuingLimit,
              'Manager Card Issuing Limit',
              diff.fieldErrorMap
            )}
          {displayCardIssuingDiff &&
            diff.cardIssuingRules.canIssuePhysicalCards !== undefined &&
            constructField(
              'canIssuePhysicalCards',
              diff.cardIssuingRules.canIssuePhysicalCards,
              'Is Physical Card Issuing Enabled',
              diff.fieldErrorMap
            )}
          {teamFields}
        </div>
        <br />
      </div>
    );
  }
}
